import React from 'react';
// import ReactGA from 'react-ga4';
// import { hotjar } from 'react-hotjar';

import { ConsumptionProvider, EvChargingProvider, OmaLummeProvider } from './omaLummeContext';

import './css/App.scss';

import CurrentPage from './components/Layout/CurrentPage';
// Utils.
import { inIframe } from './utils/login';
import AlertBanner from './components/Common/AlertBanner';

const App: React.FunctionComponent = () => {
  const [showAlertBanner, setShowAlertBanner] = React.useState(true);
  const [singleComponent, setSingleComponent] = React.useState(false);

  // // Google analytics.
  // if (import.meta.env.VITE_GA_CODE) {
  //   ReactGA.initialize(import.meta.env.VITE_GA_CODE, {
  //     gaOptions: {
  //       siteSpeedSampleRate: 100,
  //     },
  //   });
  // }
  // // Hotjar
  // if (import.meta.env.VITE_HOTJAR_HJID && import.meta.env.VITE_HOTJAR_HJSV) {
  //   hotjar.initialize(parseInt(import.meta.env.VITE_HOTJAR_HJID), parseInt(import.meta.env.VITE_HOTJAR_HJSV));
  // }

  const isIframe = inIframe();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const param = params.get('code');

  React.useEffect(() => {
    if (window.location.pathname.includes('/embed/')) {
      setSingleComponent(true);
      Array.from(document.getElementsByTagName('body') as HTMLCollectionOf<HTMLElement>)[0].style.backgroundColor = '#ffffff';
      Array.from(document.getElementsByClassName('boost-trigger-button') as HTMLCollectionOf<HTMLElement>)[0].style.display = 'none';
    }
  }, []);

  return (
    <div className="App">
      <OmaLummeProvider>
        <ConsumptionProvider>
          <EvChargingProvider>
            {!singleComponent && showAlertBanner && (!isIframe || !param) && <AlertBanner setShowAlertBanner={setShowAlertBanner} />}
            <CurrentPage singleComponent={singleComponent} />
          </EvChargingProvider>
        </ConsumptionProvider>
      </OmaLummeProvider>
    </div>
  );
};

export default App;
